// The subpages of the Admin tab: `/admin` lists them, `/admin/<key>` shows one (the Bot subpage has its own route, `/admin/bot`).
export interface AdminSection {
  key: string
  icon: string
  titleKey: string // (i18n keys)
  hintKey: string
  group: 'server' | 'data'
}

export const ADMIN_SECTIONS: readonly AdminSection[] = [
  { key: 'build', icon: '🧱', titleKey: 'admin.sections.build', hintKey: 'admin.sections.buildHint', group: 'server' },
  { key: 'settings', icon: '🎛️', titleKey: 'admin.sections.settings', hintKey: 'admin.sections.settingsHint', group: 'server' },
  { key: 'database', icon: '💾', titleKey: 'admin.sections.database', hintKey: 'admin.sections.databaseHint', group: 'server' },
  { key: 'calendars', icon: '📅', titleKey: 'admin.sections.calendars', hintKey: 'admin.sections.calendarsHint', group: 'data' },
  { key: 'tokens', icon: '🔑', titleKey: 'admin.sections.tokens', hintKey: 'admin.sections.tokensHint', group: 'data' },
]

// The section a route parameter names, or none if it is unknown.
export function findAdminSection(key: unknown): AdminSection | undefined {
  return typeof key === 'string' ? ADMIN_SECTIONS.find((section) => section.key === key) : undefined
}
